import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Produzioni from "@/components/Produzioni";
import ChiSiamo from "@/components/ChiSiamo";
import Team from "@/components/Team";
import Stampa from "@/components/Stampa";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <LanguageProvider>
            <div className="min-h-screen overflow-x-clip bg-ink font-body text-slate-100">
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <Produzioni />
                    <ChiSiamo />
                    <Team />
                    <Stampa />
                    <Contatti />
                </main>
                <Footer />
                <Toaster theme="dark" position="bottom-right" richColors closeButton />
            </div>
        </LanguageProvider>
    );
}
